<span [class.kal-tab-header-disabled]="disabled"
      [class.kal-tab-header-selected]="selected"
      [class.kal-tab-header-highlighted]="highlighted">

  <ng-container *ngIf="!content; else improvedLabel">

    {{ label }}

  </ng-container>

  <ng-template #improvedLabel>

    <ng-template cdkPortalOutlet>
    </ng-template>

  </ng-template>

</span>
